import axios from 'axios';

export const getMenuItbiAll = () => axios.get('/admin/menucidadao/all');

export const getPermissaoAcessoCidadao = () =>
  axios.get('/admin/menucidadao/permissao-acesso-cidadao');
